import classNames from 'classnames';

import type { ReactNode } from 'react';

import './InfoCard.css';

type Props = {
  className?: string;
  children: ReactNode;
};

const InfoCard = ({ className, children }: Props) => {
  return <div className={classNames('ds-u-padding--2', 'ic-info-card', className)}>{children}</div>;
};

export default InfoCard;
